/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Driver_EmailInputs */

const en_case_field_driver_email = /** @type {(inputs: Case_Field_Driver_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact email`)
};

const pt_br2_case_field_driver_email = /** @type {(inputs: Case_Field_Driver_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail de contato`)
};

/**
* | output |
* | --- |
* | "Contact email" |
*
* @param {Case_Field_Driver_EmailInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_driver_email = /** @type {((inputs?: Case_Field_Driver_EmailInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Driver_EmailInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_driver_email(inputs)
	return pt_br2_case_field_driver_email(inputs)
});